<p-dialog
        [(visible)]="visible"
        [modal]="true"
        [header]="'Update Manufacturer'"
        [closable]="true"
        [resizable]="false"
        [draggable]="false"
        [style]="{ width: '600px' }"
        (onHide)="close()"
>
    <div class="flex flex-col gap-6 my-3">
        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-building"></p-inputicon>
                <input
                        pInputText
                        id="name"
                        [(ngModel)]="manufacturer.name"
                        autocomplete="off"
                        class="w-full"
                />
            </p-iconfield>
            <label for="name">Manufacturer Name <span class="text-red-500">*</span></label>
        </p-ifta-label>

        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-map-marker"></p-inputicon>
                <input
                        pInputText
                        id="street"
                        [(ngModel)]="manufacturer.address.street"
                        autocomplete="off"
                        class="w-full"
                        placeholder="Street"
                />
            </p-iconfield>
            <label for="street">Street</label>
        </p-ifta-label>

        <div class="grid grid-cols-2 gap-4">
            <p-ifta-label>
                <input
                        pInputText
                        id="city"
                        [(ngModel)]="manufacturer.address.city"
                        autocomplete="off"
                        class="w-full"
                        placeholder="City"
                />
                <label for="city">City</label>
            </p-ifta-label>

            <p-ifta-label>
                <input
                        pInputText
                        id="zip-code"
                        [(ngModel)]="manufacturer.address.zipCode"
                        autocomplete="off"
                        class="w-full"
                        placeholder="Zip Code"
                />
                <label for="zip-code">Zip Code</label>
            </p-ifta-label>
        </div>

        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-envelope"></p-inputicon>
                <input
                        pInputText
                        id="mail"
                        [(ngModel)]="manufacturer.mail"
                        autocomplete="off"
                        class="w-full"
                />
            </p-iconfield>
            <label for="mail">Email*</label>
        </p-ifta-label>

        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-calendar"></p-inputicon>
                <p-date-picker
                        [(ngModel)]="contractExpirationDate"
                        id="contract-expiration-date"
                        class="w-full"
                        dateFormat="dd.mm.yy"
                        appendTo="body"
                ></p-date-picker>
            </p-iconfield>
            <label for="contract-expiration-date">Contract Expiration Date</label>
        </p-ifta-label>

        <p-ifta-label>
            <textarea
                    pTextarea
                    id="note"
                    class="w-full"
                    [(ngModel)]="manufacturer.note"
                    rows="3"
                    cols="30"
                    style="resize: none"
            ></textarea>
            <label for="note">Note</label>
        </p-ifta-label>

        <p class="text-gray-400 text-xs">Fields marked with <span class="text-red-500">*</span> are mandatory.</p>
    </div>
    <div class="flex justify-end gap-2 mt-10">
        <p-button
                label="Cancel"
                icon="pi pi-times"
                class="p-button-text"
                (click)="close()"
                severity="secondary"
        ></p-button>
        <p-button
                label="Save"
                icon="pi pi-check"
                (click)="updateManufacturer()"
                [loading]="loading"
        ></p-button>
    </div>
</p-dialog>
